<form *ngIf="isAccessRestrictionActive || isBulk" [formGroup]="form">
    <div class="form-group">
        <label>
            {{ l('PermissionAccessRestriction_DropdownLabel') }} *
            <app-mazars-information-icon
                uid="PermissionAccessRestriction_DropdownDescription"
                message="{{ l('PermissionAccessRestriction_DropdownDescription') }}"
            ></app-mazars-information-icon>
        </label>
        <div>
            <app-mazars-multiselect
                [id]="'PermissionAccessRestriction'"
                [items]="isAccessRestrictionActive || isBulk ? items : []"
                [isUserOrOrganization]="true"
                formControlName="accessPermission"
                [placeholder]="isAccessRestrictionActive || isBulk ? l('Select') : l('Disabled')"
                (onValueChange)="onAccessRestrictionChange($event)"
                [uid]="'mazars_access_restiction_accessPermission'"
            ></app-mazars-multiselect>
        </div>
        <app-mazars-validation-message
            [uid]="'mazars_access_restiction_accessPermission'"
            [key]="l('PermissionAccessRestriction_DropdownLabel')"
            [control]="form.controls.accessPermission"
            [submitting]="submitting"
        ></app-mazars-validation-message>
    </div>
</form>
